<mat-dialog-content>
  <mat-icon class="mb-2">{{ data.icon }}</mat-icon>
  <div class="title mb-2">{{ data.title }}</div>
  <div class="description mb-2">{{ data.description }}</div>
  <ul>
    <li *ngFor="let user of data.users">
      <strong>{{ user.username }}</strong>
      <span *ngIf="user.name"> ({{ user.name }} {{user.lastName}})</span>
    </li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button (click)="onCancel()" class="button-cancel">
    {{ data.cancelButtonText || 'Cancelar' }}
  </button>
  <button mat-flat-button color="warn" (click)="onConfirm()">
    {{ data.confirmButtonText }}
  </button>
</mat-dialog-actions>
<button mat-button mat-dialog-close class="dialog-close">
  <mat-icon>close</mat-icon>
</button>